
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as moment from 'moment';
import { PageBase } from 't4core';
import { LocationInfo, OpenHourSetting, ContentTemplateInfo } from 't4core';
import { EditOpenHoursDialog } from '../../dialogs/editOpenHoursDialog/editOpenHoursDialog';
import { Router } from '@angular/router';
import { ServiceGuyInfo } from '../../../../../projects/t4core/src/public-api';
@Component({
    styleUrls: ['./Location.css'],
    selector: 'Location',
    templateUrl: './Location.component.html',
})
export class LocationComponent extends PageBase implements OnInit {
  public invoiceAddress: any = {};
    public location: LocationInfo = new LocationInfo();
    public serviceLocation: LocationInfo = new LocationInfo();
    public specificDate: moment.Moment = moment();

    public everyDay: OpenHourSetting;
    public monday: OpenHourSetting;
    public tuesday: OpenHourSetting;
    public wednesday: OpenHourSetting;
    public thursday: OpenHourSetting;
    public friday: OpenHourSetting;
    public saturday: OpenHourSetting;
    public sunday: OpenHourSetting;
    public specific: OpenHourSetting[] = [];

    public emailTemplates: ContentTemplateInfo[] = [];
    public selectedEmailTemplate: ContentTemplateInfo   ;

    public mayEdit: boolean = false;
    public serviceGuy: ServiceGuyInfo;
    public serviceGuys: ServiceGuyInfo[]; 

    public serviceGuyControl = new FormControl<ServiceGuyInfo | string>(null);
    public filteredServiceGuys: Observable<ServiceGuyInfo[]>;

  public loadingServiceGuys: boolean = false;

    public options: any = {
        placeholderText: 'Edit Your mask Here!',
        charCounterCount: true,
        height: 700
        //toolbarButtons: ["bold", "italic", "image", "align"]
    }

    @ViewChild('gmap', {static: true}) gmapElement: ElementRef;

  constructor(el: ElementRef, private router: Router) {
        super(el, "Settings");

        
    }

  async ngOnInit() {
    this.mayEdit = this.Settings.isInAny(['LocationManager']);
    this.Api.get<OpenHourSetting[]>("Location/GetOpenHoursForEdit", { locationId: this.Settings.clientSettings.RentalLocationId }).then(x => {
      this.everyDay = x.find(y => y.DayOfWeek == 0);
      this.monday = x.find(y => y.DayOfWeek == 1);
      this.tuesday = x.find(y => y.DayOfWeek == 2);
      this.wednesday = x.find(y => y.DayOfWeek == 3);
      this.thursday = x.find(y => y.DayOfWeek == 4);
      this.friday = x.find(y => y.DayOfWeek == 5);
      this.saturday = x.find(y => y.DayOfWeek == 6);
      this.sunday = x.find(y => y.DayOfWeek == 7);

      this.specific = x.filter(y => y.DayOfWeek == null);
    });


    this.invoiceAddress = await this.Api.get<LocationInfo>("Location/GetInvoiceAddress", { id: this.Settings.clientSettings.RentalLocationId });
    this.location = await this.Api.get<LocationInfo>("Location/GetLocationInfo", { id: this.Settings.clientSettings.RentalLocationId });
    this.serviceLocation = await this.Api.get<LocationInfo>("Location/GetServiceLocation", { locationId: this.Settings.clientSettings.RentalLocationId });
    var pos = new google.maps.LatLng(this.location.Latitude, this.location.Longitude);

    this.gmapElement.nativeElement.src = "https://maps.googleapis.com/maps/api/staticmap?center=" + pos.lat() + "," + pos.lng() + "&zoom=10&size=338x250&maptype=roadmap&markers=" + pos.lat() + "," + pos.lng() + "&key=AIzaSyAPITA4UuI9ERN_XiTDXZC1packZFkx-xE";

    this.emailTemplates = await this.Api.get<ContentTemplateInfo[]>("Settings/GetEmailTemplates");

    // this.options.placeholderText = this.emailTemplates[1].Content;

    this.serviceGuy = await this.Api.get<ServiceGuyInfo>("Service/GetLocationServiceGuy", { locationId: this.Settings.clientSettings.RentalLocationId })

    
    this.loadingServiceGuys = true;
    this.serviceGuys = await this.Api.get<ServiceGuyInfo[]>("Service/GetServiceGuys");

    this.serviceGuyControl.setValue(this.serviceGuy ?? null);
    this.filteredServiceGuys = this.serviceGuyControl.valueChanges.pipe(
      startWith(this.serviceGuyControl.value),
      map(value => this.filterServiceGuys(value))
    );
    this.loadingServiceGuys = false;
  }

  private filterServiceGuys(value: ServiceGuyInfo | string): ServiceGuyInfo[] {
    const query = (typeof value === 'string' ? value : this.formatServiceGuy(value))?.toLowerCase() ?? '';
    if (!query) return this.serviceGuys ?? [];

    return (this.serviceGuys ?? []).filter(x => {
      const haystack = `${x.Identifier ?? ''} ${x.Lastname ?? ''} ${x.Firstname ?? ''}`.toLowerCase();
      return haystack.includes(query);
    });
  }

  public formatServiceGuy = (g: ServiceGuyInfo | null): string => {
    if (!g) return '';
    return `${g.Identifier} - ${g.Lastname} ${g.Firstname}`;
  }


  public async editTime(dayOfWeek: number, opens: moment.Moment, closes: moment.Moment, closed: boolean) {
        if (!this.mayEdit) {
            this.UI.alert('Turbo.Settings.Location.headRequireAdmin', 'Access is denied', 'Turbo.Settings.Location.msgRequireAdmin', 'You have to sign in as Admin to change these settings.');
            return;
        }

        var ret = await this.Dialog.open(EditOpenHoursDialog, {
            data: {
                startTime: opens,
                endTime: closes,
                dayOfWeek: dayOfWeek,
                closed: closed,
            }
        }).afterClosed().toPromise();

        if (ret === true) {
            this.ngOnInit();
        }
    }

    public async editSpecific(specificDate: moment.Moment, opens: moment.Moment, closes: moment.Moment) {
        if (!this.mayEdit) {
            this.UI.alert('Turbo.Settings.Location.headRequireAdmin', 'Access is denied', 'Turbo.Settings.Location.msgRequireAdmin', 'You have to sign in as Admin to change these settings.');
            return;
        }

        var dt = specificDate.clone().startOf("day").add(12, 'hour');

        var ret = await this.Dialog.open(EditOpenHoursDialog, {
            data: {
                startTime: opens,
                endTime: closes,
                specificDate: dt
            }
        }).afterClosed().toPromise();

        if (ret === true) {
            this.ngOnInit();
        }
    }

    public async clearTime(dayOfWeek: number, specificDate: moment.Moment) {
        if (!this.mayEdit) {
            this.UI.alert('Turbo.Settings.Location.headRequireAdmin', 'Access is denied', 'Turbo.Settings.Location.msgRequireAdmin', 'You have to sign in as Admin to change these settings.');
            return;
        }

        var x = await this.UI.confirm('turbo.Settings.MyStore.headConfirmDelete', 'Confirm deletion', 'turbo.Settings.MyStore.msgConfirmDelete', 'Are you sure that you want to delete these times?');
        if (!x) return;

        await this.Api.post("Location/ClearOpenHours", null, {
            dayOfWeek: dayOfWeek,
            specificDate: specificDate == null ? null : specificDate.toISOString(),
        });

        this.ngOnInit();
  }

  public async assignServiceGuy() {
    const selected = this.serviceGuyControl.value;
    this.serviceGuy = typeof selected === 'string' ? null : selected;
    if (!this.serviceGuy?.Id) return;

    await this.Api.post<boolean>("Service/AssignServiceGuy", null, { guyId: this.serviceGuy.Id, locationId: this.Settings.clientSettings.RentalLocationId });
  }

  public gotoSupport() {
    this.router.navigateByUrl("/Support");
  }
}
